import React from 'react'
import EDInputText from '../../../../../Component/EnhancedData/EDInputText'
import { DataWithKey, TextFieldDefinition } from '../../../../../Component/EnhancedData/Types'

interface Props {
  value: number
  onInputChange: (name: string, value: any) => void
  fieldDefinition: DataWithKey<TextFieldDefinition>
  emptyColSpan?: number
  onInputError?: (fieldName: string, errorMessage: string | null) => void
}

export default function SurchargeAmountRow (props: Props): React.JSX.Element {
  const { value, onInputChange, onInputError, fieldDefinition, emptyColSpan = 4 } = props
  const maxColSpan = 7
  const reservedColSpan = maxColSpan - emptyColSpan

  return (
    <tr className="subtotal-row">
      <td colSpan={emptyColSpan}></td>
      <td colSpan={reservedColSpan} className="subtotal-input-cell">
        <EDInputText
          value={value}
          onInputChange={onInputChange}
          onInputError={onInputError}
          fieldDefinition={fieldDefinition}
          prefixInput={'$'}
          separator={'+'}
          className={'subtotal-input label-left'}
          runValidationNow={false}
          readOnly={true}
        />
      </td>
    </tr>
  )
}
